import { parseQueryString } from 'src/utils/browser';

export const getLoginType = () => {
  let loginType = 'normal';
  if (window.location.href.indexOf('sso') > -1) {
    loginType = 'sso';
  }
  return loginType;
};

export const getSSOReferrer = (): {
  referrer?: string;
  redirectUrl?: string;
} => {
  if (getLoginType() === 'sso') {
    const { referrer } = parseQueryString();
    const storedReferrer = localStorage.getItem('x-sl-sso-signin-referrer');
    return {
      referrer: (referrer as string) || storedReferrer || 'gitbook',
      redirectUrl: localStorage.getItem('x-sl-sso-signin-redirect-url') || ''
    };
  }
  return {
    referrer: undefined,
    redirectUrl: undefined
  };
};

export const saveSSOReferrer = () => {
  if (getLoginType() === 'sso') {
    const { referrer, location } = parseQueryString();
    const storedReferrer = localStorage.getItem('x-sl-sso-signin-referrer');
    const storedRedirectUrl = localStorage.getItem('x-sl-sso-signin-redirect-url');
    localStorage.setItem('x-sl-sso-signin-referrer', (referrer as string) || storedReferrer || 'gitbook');
    localStorage.setItem('x-sl-sso-signin-redirect-url', (location as string) || storedRedirectUrl || '');
  } else {
    localStorage.removeItem('x-sl-sso-signin-referrer');
    localStorage.removeItem('x-sl-sso-signin-redirect-url');
  }
};

export const handleSSORedirect = (jwtToken: string) => {
  // Skip redirect on sign-out
  if (window.location.href.includes('/sign_out')) {
    return;
  }

  const { referrer, redirectUrl: location } = getSSOReferrer();
  console.log('sso location', location);

  // Map referrers to base URLs
  const referrerMap: Record<string, string> = {
    'gitbook': 'https://enterprise-help.stackline.com',
    'stackline-support-portal': 'https://enterprise-help.stackline.com',
    'atlas-llm': 'https://atlas-llm.stackline.com',
    'atlas-llm-localhost': 'https://atlas-llm-localhost.stackline.com',
    'zenith': 'https://zenith.stackline.com',
    'zenith-localhost': 'https://zenith-localhost.stackline.com',
    'zenith-dev': 'https://zenith-dev.stackline.com',
    'advisor': 'https://advisor.stackline.com',
    'advisor-localhost': 'https://advisor-localhost.stackline.com',
    'advisor-dev': 'https://advisor-dev.stackline.com',
    'advisor-alpha': 'https://advisor-alpha.stackline.com',
  };

  const baseUrl = referrerMap[referrer];
  if (!baseUrl) {
    throw new Error('Invalid SSO referrer');
  }

  const targetPath = location ? decodeURIComponent(location) : '';
  // Remove leading slash from targetPath to avoid double slashes
  const cleanPath = targetPath.startsWith('/') ? targetPath.slice(1) : targetPath;
  const redirectUrl = `${baseUrl}/${cleanPath}?jwt_token=${jwtToken}`;

  // Clear the persisted referrer now that login is complete. This prevents
  // a stale referrer from showing the wrong logo on a future direct visit to
  // enterprise-sso without a ?referrer param.
  localStorage.removeItem('x-sl-sso-signin-referrer');
  localStorage.removeItem('x-sl-sso-signin-redirect-url');

  window.location.href = redirectUrl;
};
